import type { CityConfig } from "../city-template/types";

export const limaConfig: CityConfig = {
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Ohio Department of Health", href: "https://odh.ohio.gov/know-our-programs/vital-statistics", description: "Official Ohio vital records office in Columbus" },
    { label: "Marriage Licenses — Allen County Probate Court", href: "https://www.allencountyohio.com/probate-court", description: "Allen County Probate Judge — marriage license issuance" },
    { label: "Divorce Records — Allen County Clerk of Courts", href: "https://www.allencountyohio.com/clerk-of-courts", description: "Allen County Clerk of Courts — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Ohio Department of Health for online vital record orders" },
  ],
  city: "Lima",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "lima-oh",
  route: "/lima-oh",
  title: "Emergency Passport Lima, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Lima, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Allen County and northwest Ohio. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Lima, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Lima and northwest Ohio travelers — including Shawnee Township and Elida — get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Lima%20Ohio%20downtown%20cityscape%20with%20historic%20architecture%20along%20Main%20Street%2C%20charming%20midwestern%20city%20center%20with%20tree-lined%20streets%2C%20warm%20golden%20hour%20lighting%2C%20small%20town%20American%20atmosphere%20with%20brick%20buildings%20and%20well-maintained%20storefronts%2C%20professional%20urban%20photography%20with%20warm%20earth%20tones%20and%20a%20clear%20sky&width=1800&height=700&seq=lima-oh-hero-001&orientation=landscape",
  heroImageAlt: "Lima Ohio downtown Main Street with historic architecture at golden hour",
  geoPosition: "40.7426;-84.1052",
  geoPlacename: "Lima, Ohio",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 240 miles from Lima via I-80",
  },
  nearbyCitiesZips: [
    { name: "Lima", zips: "45801–45807" },
    { name: "Shawnee Township", zips: "45801, 45804, 45805" },
    { name: "Elida", zips: "45807" },
    { name: "Bath Township", zips: "45801, 45833" },
    { name: "American Township", zips: "45801, 45805" },
    { name: "Wapakoneta", zips: "45895" },
    { name: "Delphos", zips: "45833" },
    { name: "Bluffton", zips: "45817" },
    { name: "Ottawa", zips: "45875" },
    { name: "Kenton", zips: "43326" },
    { name: "Celina", zips: "45822" },
    { name: "St. Marys", zips: "45885" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Lima departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-global-line", title: "Northwest Ohio Coverage", desc: "Serving Allen, Auglaize, and Putnam County travelers" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Findlay, OH", route: "/findlay" },
    { name: "Fast passport renewal in Toledo, OH", route: "/toledo" },
    { name: "Emergency passport help in Dayton, OH", route: "/dayton" },
    { name: "Urgent passport services in Columbus, OH", route: "/columbus-oh" },
    { name: "Same-day passport help in Cincinnati, OH", route: "/cincinnati" },
    { name: "Passport courier services in Fort Wayne, IN", route: "/fort-wayne" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Lima remotely via secure courier. We do not have a walk-in office in Lima — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Allen County and northwest Ohio travelers.",
  fpcOfficeDistance: "Serving all of Allen County and northwest Ohio",
  fpcOfficeAddress: "175 S Third St, Ste 200, Columbus, Ohio 43215",
  serviceAreaIntro: "From downtown Lima to Shawnee Township and Elida, from Bath Township to Wapakoneta and Delphos — Fast Passport Center serves the entire northwest Ohio region. We regularly help travelers from Allen, Auglaize, and Putnam counties get their passports fast.",
  nearbyCitiesIntro: "We serve all Lima neighborhoods and the surrounding northwest Ohio region including Shawnee Township, Elida, Bath Township, American Township, Wapakoneta, Delphos, Bluffton, Ottawa, Kenton, Celina, and St. Marys. If you are anywhere in the Lima metropolitan area or northwest Ohio, we have you covered.",
  howItWorksIntro: "Most Lima travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Lima travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Lima and northwest Ohio travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Lima? Here are the most common ones we hear from Allen County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Lima international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer M.",
      location: "Lima, OH",
      rating: 5,
      text: "My passport expired three weeks before my business trip to Toronto. Fast Passport Center had my renewal ready in 5 days. They walked me through every step and made it so easy.",
      service: "Passport Renewal",
    },
    {
      name: "Robert K.",
      location: "Shawnee Township, OH",
      rating: 5,
      text: "Family emergency required me to fly to Germany within 48 hours. Fast Passport Center got my emergency passport processed in under 36 hours. I cannot thank them enough.",
      service: "Emergency Passport",
    },
    {
      name: "Michelle T.",
      location: "Wapakoneta, OH",
      rating: 5,
      text: "Applied for my daughter's first passport for our cruise. They found the nearest acceptance facility in Lima and had her passport ready in 6 days. Wonderful service.",
      service: "Child Passport",
    },
    {
      name: "David R.",
      location: "Elida, OH",
      rating: 5,
      text: "Lost my passport the week before my Mexico vacation. Fast Passport Center handled the DS-64 form and got me a replacement in 4 days. Saved my vacation.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "lima-1",
      name: "Lima Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "310 E High St",
      city: "Lima",
      state: "OH",
      zip: "45801",
      phone: "(419) 222-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Lima",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main downtown facility. High volume — appointments strongly recommended. Photo services available on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "lima-2",
      name: "Elida Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 E Main St",
      city: "Elida",
      state: "OH",
      zip: "45807",
      phone: "(419) 339-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Elida, west of Lima",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Elida and American Township residents. Less crowded than downtown. Call for appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "lima-3",
      name: "Wapakoneta Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "301 W Auglaize St",
      city: "Wapakoneta",
      state: "OH",
      zip: "45895",
      phone: "(419) 738-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Auglaize County, 15 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Auglaize County residents. Ample parking. Call ahead for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "lima-4",
      name: "Delphos Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "228 N Main St",
      city: "Delphos",
      state: "OH",
      zip: "45833",
      phone: "(419) 695-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Allen County west, 20 miles",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative for west Allen County and Delphos area residents. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "lima-5",
      name: "Allen County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "301 N Main St",
      city: "Lima",
      state: "OH",
      zip: "45801",
      phone: "(419) 223-8513",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Allen County Courthouse, downtown Lima",
      website: "https://www.allencountyohio.com/",
      websiteLabel: "Allen County Courts",
      notes: "Accepts passport applications. Good alternative to post office with extended hours and appointment availability.",
      icon: "ri-government-line",
    },
    {
      id: "lima-6",
      name: "Kenton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "111 N Detroit St",
      city: "Kenton",
      state: "OH",
      zip: "43326",
      phone: "(419) 675-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Hardin County, 25 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Hardin County residents east of Lima. Call for appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Lima photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Allen County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Lima applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Allen County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Lima travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Lima." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Lima address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Lima before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Lima for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4 hour drive to Chicago." },
    { q: "How fast can I renew my passport in Lima?", a: "Fast Passport Center offers fast passport renewal in Lima in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "Can I get a same-day passport appointment near Lima?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 240 miles from Lima via I-80 — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Allen County residents." },
    { q: "Can I expedite a child passport in Lima?", a: "Yes. Fast Passport Center expedites child passports in Lima for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Allen County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Lima with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "What is the closest passport agency to Lima?", a: "The nearest regional passport agency to Lima is the Chicago Passport Agency, approximately 240 miles away via I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Lima without any in-person agency visit required." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Can you help travelers from Wapakoneta and Delphos?", a: "Absolutely. Fast Passport Center serves all of Allen County and the surrounding northwest Ohio region including Wapakoneta, Delphos, Bluffton, Ottawa, Kenton, Celina, and St. Marys. Our courier service works seamlessly from any zip code in the area." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Lima", address: "2405 Elida Rd, Lima, OH 45805", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Lima", address: "1275 Bellefontaine Ave, Lima, OH 45804", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Lima", address: "2400 Allentown Rd, Lima, OH 45805", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Lima", address: "1105 S Main St, Lima, OH 45804", hours: "Mon–Sun: 9AM–9PM" },
    { name: "CVS Pharmacy — Wapakoneta", address: "1250 S Vance St, Wapakoneta, OH 45895", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Delphos", address: "1200 E 5th St, Delphos, OH 45833", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Kenton", address: "1474 E US-68, Kenton, OH 43326", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Celina", address: "1105 W Logan St, Celina, OH 45822", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "Lima BMV — Allen County",
      address: "750 Shawnee Rd, Lima, OH 45805",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "Wapakoneta BMV — Auglaize County",
      address: "1010 S Water St, Wapakoneta, OH 45895",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Auglaize County driver's license and REAL ID services. Alternative for south Lima residents.",
      featured: false,
    },
    {
      name: "Kenton BMV — Hardin County",
      address: "114 S Main St, Kenton, OH 43326",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Hardin County BMV. Alternative for east Lima and Kenton area residents.",
      featured: false,
    },
    {
      name: "Celina BMV — Mercer County",
      address: "123 W Livingston St, Celina, OH 45822",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Mercer County BMV. Alternative for west Lima and Celina area residents.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "AOH",
      name: "Lima Allen County Airport",
      distance: "5 miles from downtown Lima",
      address: "800 Latham Rd, Lima, OH 45807",
      note: "Regional airport serving northwest Ohio with general aviation and charter services. Commercial flights connect through Dayton and Columbus.",
      flightUrl: "https://www.limaohio.com/airport",
      flightLabel: "Lima Airport",
      featured: true,
    },
    {
      code: "DAY",
      name: "Dayton International Airport",
      distance: "75 miles south of Lima",
      address: "3600 Terminal Dr, Dayton, OH 45377",
      note: "Nearest major commercial airport with direct flights to major hubs. Alternative for Lima travelers.",
      flightUrl: "https://flydayton.com/",
      flightLabel: "Dayton Airport",
      featured: false,
    },
    {
      code: "CMH",
      name: "John Glenn Columbus International Airport",
      distance: "95 miles east of Lima",
      address: "4600 International Gateway, Columbus, OH 43219",
      note: "Larger hub with additional international routes. Consider for long-haul international trips.",
      flightUrl: "https://www.flycmh.com/",
      flightLabel: "Columbus Airport",
      featured: false,
    },
  ],
};